import { Trash } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from 'shared/components/ui/empty-state';

export const TrashEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return <EmptyState icon={Trash} title={t('trash.empty-state-title')} />;
};
